import { render, staticRenderFns } from "./AccionesFaltante.vue?vue&type=template&id=1373ae32"
import script from "./AccionesFaltante.vue?vue&type=script&lang=js"
export * from "./AccionesFaltante.vue?vue&type=script&lang=js"
import style0 from "./AccionesFaltante.vue?vue&type=style&index=0&id=1373ae32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports